//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import SAP_BASIC_02 from './SAP_BASIC_02';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useSave } from '../../../../hooks/useSaveN';
import useDelete from '../../../../hooks/useDeleteN';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import {
  setFileFields,
  resetFileFields,
} from '../../../../Reducer/FileFieldReducer';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearchCode,
  useSave1,
  useSave2,
  useDelete1,
} from './SAP_BASIC_02_QUERY';
import useFileUpload from '../../../../hooks/useFileUpload';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { SAP_BASIC_02_Schema } from './SAP_BASIC_02_Schema';
import { v4 as uuidv4 } from 'uuid';
import { TrySharp } from '@mui/icons-material';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'SafetyPersonnel';

function ResolveBpmIdFromRow(row) {
  if (!row) return '';
  return row.bpmId ?? row.BpmId ?? row.BPM_ID ?? '';
}

function ResolveBpdIdFromRow(row) {
  if (!row) return '';
  const raw = row.bpdId ?? row.BpdId ?? row.BPD_ID ?? '';
  return String(raw ?? '').trim();
}

function ResolveBpdiIdFromRow(row) {
  if (!row) return '';
  const raw = row.bpdiId ?? row.BpdiId ?? row.BPDI_ID ?? '';
  return String(raw ?? '').trim();
}

/** 저장 완료된 평가표(무결성: 수정 불가) */
function IsEvaluationRowSaved(row) {
  if (!row || row.newYn === 'Y' || row.deleteYn === 'Y') return false;
  const bpdId = String(row.bpdId ?? row.BpdId ?? row.BPD_ID ?? '').trim();
  return bpdId !== '' && bpdId !== '0';
}

function BuildDefaultEvaluationItems(position, codeList = []) {
  if (!position) return [];
  return (codeList || [])
    .filter((c) => c.val2 === position)
    .map((code) => ({
      code: code.code,
      name: code.name,
      grade: '보통',
      bpdiId: '',
      evaComment: code.name || code.code || '',
    }));
}

/** 담당업무 항목 변경 시 코드 매칭·등급 기본값(보통) 유지 */
function ResolveEvaluationItemDefaults(text, position, codeList, prevItem = {}) {
  const trimmed = String(text ?? '').trim();
  const matched = (codeList || []).find((c) => {
    if (c.val2 !== position) return false;
    const codeText = String(c.code ?? '').trim();
    const nameText = String(c.name ?? '').trim();
    return trimmed === codeText || trimmed === nameText;
  });

  if (matched) {
    return {
      ...prevItem,
      code: matched.code,
      name: matched.name,
      evaComment: matched.name || matched.code || '',
      grade: prevItem?.grade || '보통',
    };
  }

  return {
    ...prevItem,
    code: trimmed,
    name: trimmed,
    evaComment: trimmed,
    grade: prevItem?.grade || '보통',
  };
}

//#region 상수

//#endregion

function SAP_BASIC_02F(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { companyInfo, custInfo, userInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );
  const searchInfo = useSelector((state) => state.SearchInfo);
  // 파일 업로드 관련 Hook
  const { SaveLogicPreview, SaveLogicFile, DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: () => {
      return `SafetyPersonnel/${searchInfo.custCd}/SAP_BASIC_02`;
    },
  });
  //로그 관련

  const rowClickData = useRef(null);

  const [rowData1, setRowData1] = useState([]); // 안전보건관리책임자 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 안전보건관리책임자 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 안전보건관리책임자 그리드 변경 시 데이터
  const [clickRowId, setClickRowId] = useState(null);

  // 파일 업로드 팝업 관련 state
  const [fileModalToggle, setFileModalToggle] = useState(false);

  // 평가표 팝업 관련 state
  const gridRef2 = useRef(); // 왼쪽 평가 목록 그리드

  const [evaluationModalToggle, setEvaluationModalToggle] = useState(false); // 평가표 팝업
  const [selectedEvaluationData, setSelectedEvaluationData] = useState(null); // 선택된 평가표 데이터
  const [evaluationListData, setEvaluationListData] = useState([]); // 평가표 목록 데이터 (왼쪽 패널)
  const [selectedEvaluationItem, setSelectedEvaluationItem] = useState(null); // 선택된 평가표 항목
  const pendingRowDataRef = useRef(null); // 첫 번째 항목 자동 선택을 위한 임시 데이터
  /** 저장 직후 Search2 onSuccess에서 매칭할 bpm/bpd (서버 신규 bpdId 등) */
  const rebindAfterSaveRef = useRef(null);
  const [pendingFirstSelection, setPendingFirstSelection] = useState(null); // 첫 번째 항목 자동 선택을 위한 임시 데이터
  const [evaluationDetailData, setEvaluationDetailData] = useState({
    // 평가표 상세 데이터 (오른쪽 패널)
    managerName: '',
    evaluationItems: [],
    opinion: '',
    improvements: '',
    bpdId: 0,
  });
  const selectedRowNosRef2 = useRef(new Set());
  const lastCheckedIndexRef2 = useRef(null);
  const currentRowIndexRef1 = useRef(null);
  const currentRowIndexRef2 = useRef(null); // 평가표 그리드 현재 행 인덱스
  const [changedModalRowData2, setChangedModalRowData2] = useState([]);
  const [deletedRowData2, setDeletedRowData2] = useState([]);
  const [codes, setCodes] = useState([]); // 코드 데이터

  // 원본 데이터 저장용 ref 추가
  const originalEvaluationDataRef = useRef(new Map()); // key: no 또는 bpdId, value: 원본 데이터

  const [addClickState, setAddClickState] = useState(false);
  const [isEvaluationReadOnly, setIsEvaluationReadOnly] = useState(false);

  const seqRef = useRef();
  const evaStartDateRef = useRef(dayjs().format('YYYY-MM-DD'));
  const evaEndDateRef = useRef(dayjs().format('YYYY-MM-DD'));

  const gridRef1 = useRef(); // 안전보건관리책임자 그리드
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);

  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.bpmId,
    getKeyFromResult: (result) => result.bpmId,
  });
  const delete1 = useDelete1();
  // 삭제 Handler
  const deleteHandler1 = useDelete({
    gridRef: gridRef2,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData2,
    updateRowData: setEvaluationListData,
    deletedRowData: deletedRowData2,
    rowData: evaluationListData,
    setChangedRowData: setChangedModalRowData2,
  });
  //#region 조회
  // 코드 조회 함수
  const { refetch: SearchCode } = useSearchCode({
    onSuccess: async (rows) => {
      const evaCodes = rows
        .filter((item) => item.groupCd === 'EVA_COMMENT')
        .map((item) => ({
          code: item.code,
          name: item.codeNm,
          val1: item.val1,
          val2: item.val2,
        }));
      setCodes(evaCodes);
    },
  });
  //안전보건인력 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
      dispatch(closeLoading());
    },
  });

  const NormalizeEvaluationItemsByText = (items) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => {
      const rawComment = String(
        item?.evaComment ?? item?.code ?? item?.name ?? ''
      ).trim();
      const matchedCode = codes.find((c) => {
        const codeText = String(c?.code ?? '').trim();
        const nameText = String(c?.name ?? '').trim();
        return rawComment === codeText || rawComment === nameText;
      });

      return {
        ...item,
        code: String(matchedCode?.code ?? rawComment).trim(),
        name: String(matchedCode?.name ?? rawComment).trim(),
        grade: item?.grade ?? item?.evaluation ?? '보통',
      };
    });
  };

  const BuildSearch2Rows = (rows) => {
    if (!Array.isArray(rows)) return [];
    const grouped = new Map();

    rows.forEach((row, idx) => {
      const bpdKey = String(
        row?.bpdId ?? row?.BpdId ?? row?.BPD_ID ?? `ROW_${idx}`
      ).trim();

      if (!grouped.has(bpdKey)) {
        grouped.set(bpdKey, {
          ...row,
          evaluationItems: Array.isArray(row?.evaluationItems)
            ? [...row.evaluationItems]
            : [],
        });
      }

      const current = grouped.get(bpdKey);
      const itemCodeRaw = row?.itemCode ?? row?.ItemCode ?? row?.evaComment;
      const itemNameRaw = row?.itemName ?? row?.ItemName;
      const itemEvaluationRaw =
        row?.itemEvaluation ?? row?.ItemEvaluation ?? row?.evaluation;
      const itemBpdiIdRaw = row?.itemBpdiId ?? row?.ItemBpdiId ?? row?.bpdiId;

      const hasItemData =
        itemCodeRaw != null ||
        itemNameRaw != null ||
        itemEvaluationRaw != null ||
        itemBpdiIdRaw != null;
      if (!hasItemData) return;

      current.evaluationItems.push({
        bpdiId:
          itemBpdiIdRaw != null && String(itemBpdiIdRaw).trim() !== ''
            ? String(itemBpdiIdRaw).trim()
            : '',
        evaComment:
          itemCodeRaw != null && String(itemCodeRaw).trim() !== ''
            ? String(itemCodeRaw).trim()
            : '',
        code:
          itemCodeRaw != null && String(itemCodeRaw).trim() !== ''
            ? String(itemCodeRaw).trim()
            : '',
        name:
          itemNameRaw != null && String(itemNameRaw).trim() !== ''
            ? String(itemNameRaw).trim()
            : String(itemCodeRaw ?? '').trim(),
        grade:
          itemEvaluationRaw != null && String(itemEvaluationRaw).trim() !== ''
            ? String(itemEvaluationRaw).trim()
            : '보통',
      });
    });

    return Array.from(grouped.values());
  };

  const ApplyEvaluationFocusRow = (
    selectedManager,
    focusRow,
    rowsWithItems
  ) => {
    if (!focusRow) return;
    let evaluationItems = focusRow.evaluationItems || [];
    const position = focusRow.position || selectedManager?.position || '';
    if (
      evaluationItems.length === 0 &&
      focusRow.newYn === 'Y' &&
      !IsEvaluationRowSaved(focusRow)
    ) {
      evaluationItems = BuildDefaultEvaluationItems(position, codes);
    }
    setIsEvaluationReadOnly(IsEvaluationRowSaved(focusRow));
    setSelectedEvaluationItem(focusRow);
    setEvaluationDetailData((prev) => ({
      ...prev,
      bpdId: focusRow.bpdId || 0,
      managerName: focusRow.managerNm || selectedManager?.managerNm || '',
      position,
      rank: focusRow.rank || selectedManager?.rank || '',
      depNm: focusRow.depNm || selectedManager?.depNm || '',
      evaluationItems,
      opinion: focusRow.opinion || '',
      improvements: focusRow.improvements || '',
      evaStartDate: focusRow.evaStartDate || dayjs().format('YYYY-MM-DD'),
      evaEndDate: focusRow.evaEndDate || dayjs().format('YYYY-MM-DD'),
    }));
    setSelectedEvaluationData([focusRow]);
    const idx = rowsWithItems.findIndex(
      (r) =>
        (focusRow.no && r.no && r.no === focusRow.no) ||
        (focusRow.bpdId != null &&
          r.bpdId != null &&
          String(r.bpdId) === String(focusRow.bpdId))
    );
    if (idx >= 0) currentRowIndexRef2.current = idx;
  };

  const { run: Search2, runAsync: Search2Async } = useSearch2({
    onSuccess: async (rows) => {
      if (pendingRowDataRef.current) {
        console.log('[SAP_BASIC_02] 평가표 이동 Search2 응답 rows:', rows);
      }
      let selectedManager =
        pendingRowDataRef.current ||
        pendingFirstSelection ||
        selectedRowData1[0];

      const rebindHint = rebindAfterSaveRef.current;
      if (rebindHint) rebindAfterSaveRef.current = null;

      // 원본 데이터 초기화
      originalEvaluationDataRef.current.clear();
      setChangedModalRowData2([]); // 조회 시 변경 데이터 초기화

      // 데이터가 없는 경우 - 같은 사업장·직책의 최근 저장분(없으면 전역 기본값)을 바로 보여줌
      if (!rows || rows.length === 0) {
        const evaluationItems = await ResolveDefaultEvaluationItems(
          selectedManager?.position
        );
        setEvaluationListData([]);
        setEvaluationDetailData((prev) => ({
          ...prev,
          bpdId: 0,
          managerName: selectedManager?.managerNm || '',
          position: selectedManager?.position || '',
          rank: selectedManager?.rank || '',
          depNm: selectedManager?.depNm || '',
          evaluationItems: evaluationItems,
          opinion: '',
          improvements: '',
          evaStartDate: dayjs().format('YYYY-MM-DD'),
          evaEndDate: dayjs().format('YYYY-MM-DD'),
        }));
        setSelectedEvaluationData(null);
        setPendingFirstSelection(null);
        pendingRowDataRef.current = null;
      } else {
        const normalizedRows = BuildSearch2Rows(rows);
        // 각 행에 evaluationItems 설정
        const rowsWithItems = normalizedRows.map((row) => {
          let evaluationItems = NormalizeEvaluationItemsByText(
            row.evaluationItems || []
          );

          const rowData = {
            ...row,
            evaluationItems: evaluationItems,
          };

          // 원본 데이터 저장 (깊은 복사)
          const originalKey = rowData.no || rowData.bpdId;
          if (originalKey) {
            originalEvaluationDataRef.current.set(
              originalKey,
              JSON.parse(JSON.stringify(rowData))
            );
          }

          return rowData;
        });

        setEvaluationListData(rowsWithItems);

        // 첫 평가표 이동 직후: 첫 행 자동 바인딩
        if (pendingRowDataRef.current && rowsWithItems.length > 0) {
          const firstItem = rowsWithItems[0];
          ApplyEvaluationFocusRow(selectedManager, firstItem, rowsWithItems);
          setPendingFirstSelection(null);
          pendingRowDataRef.current = null;
        } else if (rowsWithItems.length > 0) {
          // 재조회·저장 후: 저장 힌트 → 기존 선택 bpdId → 첫 행
          let focus = null;
          if (
            rebindHint?.bpdId != null &&
            String(rebindHint.bpdId).trim() !== ''
          ) {
            focus = rowsWithItems.find(
              (r) => String(r.bpdId) === String(rebindHint.bpdId)
            );
          }
          if (!focus && selectedEvaluationData?.[0]) {
            const pb = selectedEvaluationData[0].bpdId;
            if (pb != null && String(pb).trim() !== '') {
              focus = rowsWithItems.find((r) => String(r.bpdId) === String(pb));
            }
            if (!focus && selectedEvaluationData[0].no) {
              focus = rowsWithItems.find(
                (r) => r.no === selectedEvaluationData[0].no
              );
            }
          }
          if (!focus) focus = rowsWithItems[0];
          ApplyEvaluationFocusRow(selectedManager, focus, rowsWithItems);
        }
      }
    },
  });

  // 같은 사업장·직책으로 가장 최근에 저장된 평가항목(디폴트 템플릿) 조회
  const { runAsync: Search3Async } = useSearch3();

  // 같은 사업장·직책으로 가장 최근에 저장된 평가항목이 있으면 그걸 디폴트로,
  // 없으면 전역 공통코드 기본값으로 폴백
  const ResolveDefaultEvaluationItems = async (position) => {
    try {
      const latestItems = await Search3Async({ position }, {});
      if (Array.isArray(latestItems) && latestItems.length > 0) {
        return latestItems.map((item) => {
          const code = item.code ?? item.Code ?? '';
          const name = item.name ?? item.Name ?? code;
          return {
            code,
            name,
            grade: '보통',
            bpdiId: '',
            evaComment: name || code,
          };
        });
      }
    } catch (e) {
      /* 조회 실패 시 아래 전역 공통코드 기본값으로 대체 */
    }
    return BuildDefaultEvaluationItems(position, codes);
  };

  //#endregion
  //#region 저장
  const createSaveRequest = () => {
    const selectedRow1 = selectedRowData1[0]; // 보건인력 그리드

    // 삭제 예정 행은 저장 대상에서 제외 (삭제 후 동일 bpdId로 U2가 다시 돌면 신규 INSERT로 보일 수 있음)
    const deletedKeySet = new Set();
    (deletedRowData2 || []).forEach((d) => {
      if (
        d?.bpdId != null &&
        String(d.bpdId).trim() !== '' &&
        String(d.bpdId) !== '0'
      ) {
        deletedKeySet.add(`BPD:${String(d.bpdId)}`);
      }
      if (d?.no != null && String(d.no).trim() !== '') {
        deletedKeySet.add(`NO:${String(d.no)}`);
      }
    });

    // changedModalRowData2만 사용 (실제로 변경된 데이터만)
    const rawRowsToSave = (
      changedModalRowData2.length > 0 ? changedModalRowData2 : []
    ).filter((row) => {
      if (row?.deleteYn === 'Y') return false;
      // 저장 완료 평가표는 재저장(수정) 불가
      if (IsEvaluationRowSaved(row)) return false;
      const bpdKey =
        row?.bpdId != null &&
        String(row.bpdId).trim() !== '' &&
        String(row.bpdId) !== '0'
          ? `BPD:${String(row.bpdId)}`
          : null;
      const noKey =
        row?.no != null && String(row.no).trim() !== ''
          ? `NO:${String(row.no)}`
          : null;
      if (bpdKey && deletedKeySet.has(bpdKey)) return false;
      if (noKey && deletedKeySet.has(noKey)) return false;
      return true;
    });
    // 동일 행이 여러 이벤트 경로로 중복 적재되는 경우 1건으로 정규화
    const dedupedMap = new Map();
    rawRowsToSave.forEach((row, idx) => {
      const key =
        row?.bpdId != null && String(row.bpdId).trim() !== ''
          ? `BPD:${String(row.bpdId)}`
          : `NO:${String(row?.no ?? idx)}`;
      dedupedMap.set(key, row);
    });
    const rowsToSave = Array.from(dedupedMap.values());

    // 각 행마다 요청 객체 생성
    return rowsToSave.map((rowData) => {
      // 각 행의 evaluationItems 사용
      let evaluationItems = rowData.evaluationItems;

      // rowData에 evaluationItems가 없으면 그리드에서 찾기
      if (!evaluationItems || evaluationItems.length === 0) {
        const gridApi = gridRef2.current?.api;
        if (gridApi) {
          gridApi.forEachNode((node) => {
            if (
              node.data?.no === rowData.no ||
              node.data?.bpdId === rowData.bpdId
            ) {
              evaluationItems = node.data?.evaluationItems || [];
            }
          });
        }
      }

      return {
        // DTL 저장용. 왼쪽 기본정보 그리드는 평가표 이동 시 로우 표시용이므로 MST/저장 페이로드에 넣지 않음.
        bpmId: selectedRow1?.bpmId || '',
        bpdId: rowData.bpdId || 0,
        managerId: selectedRow1?.managerId || '',
        opinion: rowData.opinion || '',
        improvements: rowData.improvements || '',
        evaStartDate: rowData.evaStartDate || dayjs().format('YYYY-MM-DD'),
        evaEndDate: rowData.evaEndDate || dayjs().format('YYYY-MM-DD'),
        userId: Commons.DecryptoAES(userInfo.userId || ''),
        evaItem: (evaluationItems || []).map((proc) => {
          const evaCommentText = String(
            proc?.name ?? proc?.evaComment ?? proc?.code ?? ''
          ).trim();
          const bpdiIdRaw = String(
            proc?.bpdiId ??
              proc?.BpdiId ??
              proc?.itemBpdiId ??
              proc?.ItemBpdiId ??
              ''
          ).trim();
          return {
            // TB_BO_PERSONNEL_DTL_ITEMS.EVA_COMMENT(text) 저장 포맷
            bpdiId: bpdiIdRaw !== '' ? Number(bpdiIdRaw) : null,
            evaComment: evaCommentText,
            evaluation: proc.grade || '보통',
          };
        }),
      };
    });
  };
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '사업장명',
    schema: SAP_BASIC_02_Schema,
    getChangedRows: () => {
      return changedRowData1.filter((r) => !r.deleteYn);
    },
    getDeletedRows: () => [],

    requestSave: (rows) => Save1Async(rows),
    fileDelete: DeleteLogicFile,
    fileSave: (item) => {
      const _coCd =
        userInfo.authCd === 'ADMIN' ? searchInfo.coCd : userInfo.coCd || '';
      return SaveLogicFile(item, _coCd);
    },
    refresh: () => Search1(),
    reset: () => ResetLogic1(),
    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });
  const { run: Save2 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '평가표 상세정보 기입 ',
    schema: SAP_BASIC_02_Schema.modal.form,
    getChangedRows: () => {
      const saveRequests = createSaveRequest();
      // 각 요청을 JSON 직렬화하여 배열로 반환
      return saveRequests.map((saveRequest) => ({
        request: JSON.stringify(saveRequest),
      }));
    },
    getDeletedRows: () => deletedRowData2,

    // Save2 changedRows는 { request } 형태라 메인 그리드 partialRefresh와 맞지 않음 → onSuccessRefresh만 사용
    onSuccessRefresh: async ({ saveDetailData, changedRows }) => {
      let bpmId = '';
      let bpdId = '';
      let bpdiId = '';
      (changedRows || []).forEach((row) => {
        try {
          const req = row?.request;
          if (typeof req !== 'string') return;
          const obj = JSON.parse(req);
          if (obj.bpmId != null && String(obj.bpmId).trim() !== '') {
            bpmId = String(obj.bpmId);
          }
          if (obj.bpdId != null && String(obj.bpdId).trim() !== '') {
            bpdId = String(obj.bpdId);
          }
          if (obj.bpdiId != null && String(obj.bpdiId).trim() !== '') {
            bpdiId = String(obj.bpdiId);
          }
        } catch {
          // ignore
        }
      });
      const firstOk = (saveDetailData || []).find((r) => r?.isSuccess === true);
      if (firstOk) {
        // 서버 SaveSapBasic02U2 응답: result.Data = [{ BpdId, BpmId }]
        const firstData =
          Array.isArray(firstOk?.data) && firstOk.data.length > 0
            ? firstOk.data[0]
            : null;

        const resBpd =
          firstData?.bpdId ??
          firstData?.BpdId ??
          firstOk?.bpdId ??
          firstOk?.BpdId ??
          firstOk?.bpdID;
        if (resBpd != null && String(resBpd).trim() !== '') {
          bpdId = String(resBpd);
        }

        const resBpm =
          firstData?.bpmId ??
          firstData?.BpmId ??
          firstOk?.bpmId ??
          firstOk?.BpmId ??
          firstOk?.bpmID;
        if (resBpm != null && String(resBpm).trim() !== '') {
          bpmId = String(resBpm);
        }
      }
      if (!bpmId) {
        bpmId =
          ResolveBpmIdFromRow(selectedEvaluationData?.[0]) ||
          (selectedRowData1?.[0]?.bpmId != null
            ? String(selectedRowData1[0].bpmId)
            : '');
      }
      if (!bpdId || bpdId === '') {
        bpdId = ResolveBpdIdFromRow(
          selectedEvaluationData?.[0] || selectedRowData1?.[0]
        );
      }
      if (!bpdiId || bpdiId === '') {
        bpdiId = ResolveBpdiIdFromRow(
          selectedEvaluationData?.[0] || selectedRowData1?.[0]
        );
      }
      if (bpmId && bpdId !== '') {
        rebindAfterSaveRef.current = { bpmId, bpdId };
        await Search2Async({ bpmId, bpdId, bpdiId });
      } else {
        rebindAfterSaveRef.current = null;
      }
      await Search1();
    },
    requestSave: (rows) => {
      return Save2Async(rows);
    },
    requestDelete: (rows) => deleteHandler1.DeleteLogic(rows),

    afterSaveRow: async (item, { index, savedRows, userInfo }) => {},
  });
  //#endregion
  //#region 나머지 함수

  // 초기화 로직
  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };

  // 행 클릭 이벤트
  const HandleRowSelection1 = (rowData, rowIndex) => {
    // 이전에 클릭한 행(seq 기준)을 기억
    if (clickRowId === rowData.no) return; // 같은 행이면 무시

    setClickRowId(rowData.no); // 현재 클릭한 행 ID 저장
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const HandleRowSelection2 = (rowData, rowIndex) => {
    // 이전에 클릭한 행(seq 기준)을 기억
    if (clickRowId === rowData.no) return; // 같은 행이면 무시
    currentRowIndexRef2.current = rowIndex;
    setClickRowId(rowData.no); // 현재 클릭한 행 ID 저장

    setIsEvaluationReadOnly(IsEvaluationRowSaved(rowData));

    // 이미 로드된 데이터에서 evaluationItems 가져오기
    let evaluationItems = rowData.evaluationItems || [];
    const position = rowData.position || selectedRowData1?.[0]?.position || '';
    if (
      evaluationItems.length === 0 &&
      rowData.newYn === 'Y' &&
      !IsEvaluationRowSaved(rowData)
    ) {
      evaluationItems = BuildDefaultEvaluationItems(position, codes);
    }

    // 그리드의 해당 행 데이터도 업데이트
    const api = gridRef2.current?.api;
    if (api) {
      api.forEachNode((node) => {
        if (node.data?.no === rowData.no) {
          const updatedData = {
            ...node.data,
            evaluationItems: evaluationItems,
          };
          node.setData(updatedData);
        }
      });
    }

    setEvaluationDetailData((prev) => ({
      ...prev,
      bpdId: rowData.bpdId || 0,
      managerName: rowData.managerNm || '',
      position: rowData.position || '',
      rank: rowData.rank || '',
      depNm: rowData.depNm || '',
      evaluationItems: evaluationItems,
      opinion: rowData.opinion || '',
      improvements: rowData.improvements || '',
      evaStartDate: rowData.evaStartDate || dayjs().format('YYYY-MM-DD'),
      evaEndDate: rowData.evaEndDate || dayjs().format('YYYY-MM-DD'),
    }));

    setSelectedEvaluationData([rowData]);
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  // 평가표 이동 버튼 클릭 핸들러
  const handleEvaluationClick = async (rowData) => {
    if (rowData) {
      if (
        rowData.position === '안전관리자' ||
        rowData.position === '보건관리자' ||
        rowData.position === '관리감독자' ||
        rowData.position === '안전보건관리담당자' ||
        rowData.position === '안전보건총괄책임자' ||
        rowData.position === '안전보건관리책임자'
      ) {
        setEvaluationModalToggle(true);
        pendingRowDataRef.current = rowData;
        // 첫 번째 항목 자동 선택을 위한 데이터 저장
        setPendingFirstSelection(rowData);
        const bpmId = ResolveBpmIdFromRow(rowData);
        const bpdId = ResolveBpdIdFromRow(rowData);
        const bpdiId = ResolveBpdiIdFromRow(rowData);
        if (!bpmId) return;
        if (bpdId === '') {
          // 아직 평가표가 없는 사람 - 이전에 보던 다른 사람의 상세정보가 남아있지 않도록
          // 같은 사업장·직책의 최근 저장분(없으면 전역 기본값)을 바로 채워서 보여줌
          originalEvaluationDataRef.current.clear();
          setChangedModalRowData2([]);
          setEvaluationListData([]);
          setSelectedEvaluationData(null);
          setIsEvaluationReadOnly(false);
          const evaluationItems = await ResolveDefaultEvaluationItems(
            rowData.position
          );
          setEvaluationDetailData({
            bpdId: 0,
            managerName: rowData.managerNm || '',
            position: rowData.position || '',
            rank: rowData.rank || '',
            depNm: rowData.depNm || '',
            evaluationItems,
            opinion: '',
            improvements: '',
            evaStartDate: dayjs().format('YYYY-MM-DD'),
            evaEndDate: dayjs().format('YYYY-MM-DD'),
          });
          setPendingFirstSelection(null);
          pendingRowDataRef.current = null;
          return;
        }
        await Search2({ bpmId, bpdId, bpdiId });
      } else {
        return dispatch(
          showSnackbar({
            message: '평가표에 해당하지 않는 직책입니다.',
            type: 'info',
          })
        );
      }
    }
  };

  // 평가표 저장 핸들러
  const handleEvaluationSave = async () => {
    // 저장 로직 구현 필요
    dispatch(
      showSnackbar({
        message: '평가표가 저장되었습니다.',
        type: 'success',
      })
    );
  };

  // 파일 업로드 팝업 열기 (그리드 최신 행 데이터 사용 - 직책 변경 시 비워진 파일값 반영)
  const PopupFileClickEvent = async (rowData) => {
    dispatch(resetFileFields());

    const rowNode = gridRef1.current?.api?.getRowNode?.(String(rowData?.no));
    const currentRow = rowNode?.data ?? rowData;

    const fileName = currentRow.fileName || '';
    const filePath = currentRow.filePath || '';
    const previewPath = currentRow.previewFilePath || '';
    let previewUrl = '';
    if (previewPath && previewPath !== 'previewPath') {
      const fixedPath = Commons.EncodeUrl(previewPath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    } else if (filePath) {
      const fixedPath = Commons.EncodeUrl(filePath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    }
    dispatch(
      setFileFields({
        previewFileName: fileName ? fileName : '',
        previewUrl,
      })
    );

    setTimeout(() => setFileModalToggle(true), 100);
  };

  // 파일 다운로드 함수
  const DownloadLogic1 = async () => {
    const row = selectedRowData1?.[0];

    if (row?.newYn === 'Y') {
      dispatch(
        showSnackbar({
          message: '저장 후 파일 다운로드가 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    const rawPath = row?.filePath || row?.previewFilePath || '';

    if (!rawPath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = Commons.EncodeUrl(rawPath);
      const fileName = row?.mapFileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      );

      const contentType = result?.headers?.['content-type'];
      const blobData = result?.data;

      if (!blobData || !contentType) {
        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${fileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };
  const HandleAddClick = async (_gridRef) => {
    setSelectedEvaluationData([]);
    setIsEvaluationReadOnly(false);
    if (_gridRef) {
      const api = _gridRef.current.api;
      api.deselectAll();
      const schemaForm = SAP_BASIC_02_Schema.modal.form;
      const selectedManager = selectedRowData1?.[0]; // 배열이므로 첫 번째 요소 사용

      // 같은 사업장·같은 직책으로 가장 최근에 저장된 평가항목이 있으면
      // 그걸 디폴트로 사용 (없으면 전역 공통코드 기본값)
      const evaluationItems = await ResolveDefaultEvaluationItems(
        selectedManager?.position
      );
      const initialEvaluationDetailData = {
        bpdId: 0,
        evaStartDate:
          schemaForm.evaStartDate.initial || dayjs().format('YYYY-MM-DD'),
        evaEndDate:
          schemaForm.evaEndDate.initial || dayjs().format('YYYY-MM-DD'),
        managerName: selectedManager?.managerNm || '',
        position: selectedManager?.position || '',
        rank: selectedManager?.rank || '',
        depNm: selectedManager?.depNm || '',
        evaluationItems: evaluationItems,
        bpmId: selectedManager?.bpmId || '',
        opinion: schemaForm.opinion.initial || '',
        improvements: schemaForm.improvements.initial || '',
      };
      setEvaluationDetailData(initialEvaluationDetailData);

      console.log(initialEvaluationDetailData);

      const newRow = {
        managerNm: selectedManager?.managerNm || '',
        position: selectedManager?.position || '',
        rank: selectedManager?.rank || '',
        depNm: selectedManager?.depNm || '',
        managerId: selectedManager?.managerId || '',
        opinion: '',
        improvements: '',
        evaStartDate: dayjs().format('YYYY-MM-DD'),
        evaEndDate: dayjs().format('YYYY-MM-DD'),
        evaluationItems: evaluationItems, // 새 행에도 evaluationItems 포함
        no: uuidv4(), //필수값
        newYn: 'Y', //필수값
        bpdId: 0,
        bpmId: selectedManager?.bpmId || '',
      };
      _gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: 0,
      });
      const addedRowNode = _gridRef.current.api.getDisplayedRowAtIndex(0);
      if (addedRowNode) {
        currentRowIndexRef2.current = 0;
        evaStartDateRef.current = dayjs().format('YYYY-MM-DD');
        evaEndDateRef.current = dayjs().format('YYYY-MM-DD');
        addedRowNode.setSelected(true);
        setAddClickState(false);

        // 새로 추가된 행을 changedModalRowData2에 추가
        setChangedModalRowData2((prev) => {
          const filtered = prev.filter((row) => row.no !== newRow.no);
          return [...filtered, { ...newRow, editYn: 'Y' }];
        });
      }
    }
  };

  // 평가표 그리드의 현재 행 데이터 업데이트 함수
  const updateCurrentRowData1 = (fieldName, value) => {
    if (!gridRef2.current || currentRowIndexRef2.current === null) return;

    const api = gridRef2.current.api;
    const rowNode = api.getDisplayedRowAtIndex(currentRowIndexRef2.current);
    if (!rowNode) return;

    const prevData = rowNode.data;
    if (IsEvaluationRowSaved(prevData)) return;

    const rowKey = prevData.no || prevData.bpdId;

    // 원본 데이터 가져오기
    const originalData = originalEvaluationDataRef.current.get(rowKey);

    // 원본 데이터가 없으면 (신규 행) 변경된 것으로 처리
    const isNewRow = !originalData || prevData.newYn === 'Y';

    // 원본 데이터와 비교하여 실제 변경 여부 확인
    let hasChanged = isNewRow;
    if (!isNewRow && originalData) {
      // 필드별 변경 여부 확인
      if (fieldName === 'evaluationItems') {
        // evaluationItems 비교
        const originalItems = JSON.stringify(
          originalData.evaluationItems || []
        );
        const currentItems = JSON.stringify(value || []);
        hasChanged = originalItems !== currentItems;
      } else {
        hasChanged = originalData[fieldName] !== value;
      }
    }

    const updatedRowData = {
      ...prevData,
      [fieldName]: value,
      editYn: hasChanged ? 'Y' : prevData.editYn,
    };

    rowNode.setData(updatedRowData);

    // 실제 변경이 있거나 신규 행인 경우에만 changedModalRowData2에 추가
    if (hasChanged || isNewRow) {
      setChangedModalRowData2((prev) => {
        const filtered = prev.filter((row) => row.no !== updatedRowData.no);
        return [...filtered, updatedRowData];
      });
    } else {
      // 변경이 없으면 changedModalRowData2에서 제거
      setChangedModalRowData2((prev) => {
        return prev.filter((row) => row.no !== updatedRowData.no);
      });
    }
  };
  const PrintLogic1 = async (_item) => {
    try {
      // const journeymanImage =
      //   typeof custInfo.find((f) => f.custCd === props.custCd)?.journeyman ===
      //   'string'
      //     ? custCd.find((f) => f.custCd === props.custCd).journeyman
      //     : '';

      // await SearchPhoto(journeymanImage);
      const selectedRow = selectedRowData1[0];
      const coNm =
        userInfo.authCd === 'ADMIN'
          ? props.searchInfo.coList.find(
              (co) => co.value === props.searchInfo.coCd
            )?.name || ''
          : companyInfo[0]?.coNm || '';

      const ceoNm =
        userInfo.authCd === 'ADMIN'
          ? props.searchInfo.coList.find(
              (co) => co.value === props.searchInfo.coCd
            )?.ceoName || ''
          : companyInfo[0]?.ceoNm || '';

      const headerData = {
        ...selectedRow,
        userNm: selectedRow.managerNm,
        position: selectedRow.position,
        department: selectedRow.depNm,
        appointmentDate: dayjs(selectedRow.manageDate).format(
          'YYYY년 MM월 DD일'
        ),
        custNm: userInfo.custNm,
        coNm: coNm,
        ceoNm: ceoNm,
        // journeyman:
        //   imgRef.current?.replace(/^data:image\/[a-z]+;base64,/, '') || '',
      };
      let FileName = '';
      switch (selectedRow.position) {
        case '안전보건관리책임자':
          FileName = 'SAP_BASIC_02_MST';
          break;
        case '안전보건관리담당자':
          FileName = 'SAP_BASIC_02_MST';
          break;
        case '안전보건총괄책임자':
          FileName = 'SAP_BASIC_03_MST';
          break;
        case '관리감독자':
          FileName = 'SAP_BASIC_04_MST';
          break;
        case '보건관리자':
          FileName = 'SAP_BASIC_06_MST';
          break;
        default:
          FileName = '없음';
      }
      if (FileName === '없음') {
        return dispatch(
          showSnackbar({
            message: '업로드된 파일이 없습니다',
            type: 'info',
          })
        );
      }
      const printData = {
        FileName: FileName,
        HeaderData: JSON.stringify(headerData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };
  // 평가표 인쇄
  const PrintLogic2 = async (_item) => {
    dispatch(showLoading());
    let headerData = {};
    let tableData = [];
    try {
      // evaContent로 시작하고 숫자 붙은 것만 항목 개수 파악 및 정렬
      headerData = {
        ..._item,
        position: _item.position,
        name: _item.name,
        opinion: _item.opinion,
        improvements: _item.improvements,
        evaStartDate: dayjs(_item.evaStartDate).format('YYYY.MM.DD'),
        evaEndDate: dayjs(_item.evaEndDate).format('YYYY.MM.DD'),
        today: dayjs().format('YYYY.MM.DD'),
      };
      _item.evaluationItems.forEach((element) => {
        tableData.push({
          evaContent: element.name, // 담당업무
          evaluation: element.grade, // 평가
        });
      });

      const printData = {
        FileName: 'SAP_BASIC_02_DTL',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };
      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion

  return (
    <SAP_BASIC_02
      // 변수
      gridId1={'grid1'}
      navigate={navigate}
      userInfo={userInfo}
      lanInfo={lanInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      rowClickData={rowClickData}
      addClickState={addClickState}
      setAddClickState={setAddClickState}
      clickRowId={clickRowId}
      setClickRowId={setClickRowId}
      seqRef={seqRef}
      evaStartDateRef={evaStartDateRef}
      evaEndDateRef={evaEndDateRef}
      gridRef1={gridRef1}
      selectedRowNosRef1={selectedRowNosRef1}
      lastCheckedIndexRef1={lastCheckedIndexRef1}
      filterClick2={props.filterClick2}
      setFilterClick2={props.setFilterClick2}
      searchClick2={props.searchClick2}
      setSearchClick2={props.setSearchClick2}
      addClick2={props.addClick2}
      setAddClick2={props.setAddClick2}
      saveClick2={props.saveClick2}
      setSaveClick2={props.setSaveClick2}
      deleteClick2={props.deleteClick2}
      setDeleteClick2={props.setDeleteClick2}
      printClick2={props.printClick2}
      setPrintClick2={props.setPrintClick2}
      listClick2={props.listClick2}
      setListClick2={props.setListClick2}
      dispatch={dispatch}
      showSnackbar={showSnackbar}
      selectedRowNosRef2={selectedRowNosRef2}
      lastCheckedIndexRef2={lastCheckedIndexRef2}
      gridRef2={gridRef2}
      HandleAddClick={HandleAddClick}
      updateCurrentRowData1={updateCurrentRowData1}
      changedModalRowData2={changedModalRowData2}
      setChangedModalRowData2={setChangedModalRowData2}
      MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
      RestoreRow1={deleteHandler1.RestoreRow}
      DeleteNewRow1={deleteHandler1.DeleteNewRow}
      // 함수
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      Search1={Search1}
      Search2={Search2}
      Save1={Save1}
      HandleRowSelection1={HandleRowSelection1}
      HandleRowSelection2={HandleRowSelection2}
      NewYnErrorMsg={NewYnErrorMsg}
      Save2={Save2}
      PrintLogic1={PrintLogic1}
      PrintLogic2={PrintLogic2}
      SaveLogicPreview={SaveLogicPreview}
      // 파일 업로드/다운로드 관련 props
      fileModalToggle={fileModalToggle}
      setFileModalToggle={setFileModalToggle}
      PopupFileClickEvent={PopupFileClickEvent}
      DownloadLogic1={DownloadLogic1}
      // 평가표 팝업 관련 props
      evaluationModalToggle={evaluationModalToggle}
      setEvaluationModalToggle={setEvaluationModalToggle}
      selectedEvaluationData={selectedEvaluationData}
      setSelectedEvaluationData={setSelectedEvaluationData}
      evaluationListData={evaluationListData}
      setEvaluationListData={setEvaluationListData}
      selectedEvaluationItem={selectedEvaluationItem}
      setSelectedEvaluationItem={setSelectedEvaluationItem}
      evaluationDetailData={evaluationDetailData}
      setEvaluationDetailData={setEvaluationDetailData}
      handleEvaluationClick={handleEvaluationClick}
      handleEvaluationSave={handleEvaluationSave}
      currentRowIndexRef2={currentRowIndexRef2}
      isEvaluationReadOnly={isEvaluationReadOnly}
      codes={codes}
      ResolveEvaluationItemDefaults={ResolveEvaluationItemDefaults}
    />
  );
}

export default SAP_BASIC_02F;
